import { useState } from 'react';
import Web3 from "web3"
import web3Config from "./web3Config";
import Erc20Abi from "./Erc20Abi.json"
import PreSaleAbi from "./PreSaleAbi.json"



////OLD BACKUP
export const Web3connector = async () => {
    try {
        if (!window.ethereum) {
            return {
                status: false,
                message: `Please install Metamask wallet extension`,
            }
        }
        const web3 = new Web3(window.ethereum)
        let accounts = await window.ethereum.request({   /* New */
            method: "eth_requestAccounts",                 /* New */
        })

        const currentProvider = await web3.currentProvider;
        const chainId = await web3.currentProvider.chain.id;
        console.log({ currentProvider })
        if (web3.utils.toHex(parseInt(web3Config.CHAIN)) != chainId && parseInt(web3Config.CHAIN) != parseInt(chainId)) {
            return {
                status: false,
                message: `Please select ${web3Config.NETWORK} network`,
            }
        }
        return {
            status: true,
            address: accounts[0],
        }
    } catch (error) {
        console.error(error);
    }
};

////New Runing Code
// const validateProvider = async (walletProvider) => {

//     walletProvider = await walletProvider;
//     if (!walletProvider) {
//         return {
//             status: false,
//             message: `Please connect your web3 wallet`,
//         }
//     }
//     console.log({ walletProvider })
//     const web3 = new Web3(walletProvider)
//     let accounts = await walletProvider.request({   /* New */
//         method: "eth_requestAccounts",                 /* New */
//     })

//     // const accounts = await web3.eth.getAccounts()
//     const currentProvider = await web3.currentProvider;
//     const chainId = await web3.currentProvider.chainId;
//     // let ccc = await currentProvider.getChainId()
//     console.log({ currentProvider, chainId })

//     if (web3.utils.toHex(parseInt(chainId)) != parseInt(web3Config.CHAIN) && parseInt(web3Config.CHAIN) != parseInt(chainId)) {
//         return {
//             status: false,
//             message: `Please select ${web3Config.NETWORK} network`,
//         }
//     }
//     return {
//         status: true,
//         web3
//     }
// }


const validateProvider = async (walletProvider) => {
  walletProvider = await walletProvider;
  if (!walletProvider) {
    return {
      status: false,
      message: `Please connect your web3 wallet`,
    }
  }
  const web3 = new Web3(walletProvider)
  // let accounts = await walletProvider.request({   /* New */
  //   method: "eth_requestAccounts",                 /* New */
  // })
  // const currentProvider = await web3.currentProvider;

  const maticNetwork = {
    chainId: web3Config.CHAIN,
    chainName: web3Config.NETWORK,
    nativeCurrency: {
      name: web3Config.NETWORK,
      symbol: web3Config.SYMBOL,
      decimals: 18,
    },
    rpcUrls: web3Config.POLYGON_RPC,
    blockExplorerUrls: web3Config.Explore
  }

  const chainId = await web3.currentProvider.chainId;
  if (chainId != web3.utils.toHex(web3Config.CHAIN)){
    try{    
      await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: web3.utils.toHex(web3Config.CHAIN) }],
    });
   } catch(switchError) {
    if (switchError.code === 4902 || switchError.code === 32603) {
      try {
        await walletProvider.request({
          method: "wallet_addEthereumChain",
          params: [maticNetwork],
        });
      } catch (addError) {
        console.error(`Failed to add network:`, addError);
        return {
          status: false,
          message: `Failed to add the network. Please try again.`,
        };
   }
  } else {
    console.error(`Failed to switch network:`, switchError);
        return {
          status: false,
          message: `Failed to switch to the required network. Please try again.`,
        };
  }
}
  } 
  return {
    status: true,
    web3
  }
}
  

export const getUsdtBalance = async (walletAddress, UsdtContract, presaleContract, walletProvider) => {
    try {
        const validate = await validateProvider(walletProvider);
        if (!validate.status) {
            return validate;
        }
        let web3 = validate.web3;


        let usdtContract = new web3.eth.Contract(Erc20Abi, UsdtContract);

        let balance = await usdtContract.methods.balanceOf(walletAddress).call();

        let decimals = await usdtContract.methods.decimals().call();
        let allowance = await usdtContract.methods.allowance(walletAddress, presaleContract).call();

        return {
            status: true,
            balance: parseInt(balance) / 10 ** parseInt(decimals),
            allowance: parseInt(allowance) / 10 ** parseInt(decimals)
        }
    } catch (error) {
        console.error(error);
    }
};


export const BlockchainApproveToken = async (req) => {
    try {
        const { walletProvider, walletAddress, UsdtContract, presaleContract, UsdtAmount } = req;
        const validate = await validateProvider(walletProvider);
        if (!validate.status) {
            return validate;
        }
        let web3 = validate.web3;
        let chainId = web3Config.CHAIN;

        let erc20Contract = new web3.eth.Contract(Erc20Abi, UsdtContract);


        let balance = await erc20Contract.methods.balanceOf(walletAddress).call();
        let decimals = await erc20Contract.methods.decimals().call();
        let token = parseInt(UsdtAmount * 10 ** parseInt(decimals));
        // let allowance = await erc20Contract.methods.allowance(walletAddress, presaleContract).call();
        console.log("Buying : ", { token })
        let trx = await erc20Contract.methods.approve(presaleContract, token.toString());

        let encodeData = trx.encodeABI();
        let gasPrice = await web3.eth.getGasPrice();

        let gasLimit = await web3.eth.estimateGas({
            gasPrice: web3.utils.toHex(gasPrice),
            to: UsdtContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });

        const txData = await web3.eth.sendTransaction({
            gasPrice: web3.utils.toHex(gasPrice),
            gas: web3.utils.toHex(gasLimit),
            to: UsdtContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });


        return {
            status: true,
            hash: txData.transactionHash
        }
    } catch (error) {
        return {
            status: false,
            message: error.toString()
        }
    }
};


export const BlockchainBuyToken = async (req) => {
    try {
        const { walletProvider, walletAddress, UsdtContract, presaleContract, UsdtAmount } = req;

        const validate = await validateProvider(walletProvider);
        if (!validate.status) {
            return validate;
        }
        let web3 = validate.web3;
        let chainId = web3Config.CHAIN;

        let preContract = new web3.eth.Contract(PreSaleAbi, presaleContract);
        let erc20Contract = new web3.eth.Contract(Erc20Abi, UsdtContract);

        // let balance = await erc20Contract.methods.balanceOf(walletAddress).call();
        let decimals = await erc20Contract.methods.decimals().call();
        let token = parseInt(UsdtAmount * 10 ** parseInt(decimals));
        console.log("Buying : ", { token })

        let isBuyActive = await preContract.methods.isBuyActive().call();
        if (!isBuyActive) {
            return {
                status: false,
                message: `Presale token buying not started`,
            }
        }

        let trx = await preContract.methods.buy(token.toString());

        let encodeData = trx.encodeABI();
        let gasPrice = await web3.eth.getGasPrice();

        let gasLimit = await web3.eth.estimateGas({
            gasPrice: web3.utils.toHex(gasPrice),
            to: presaleContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });

        const txData = await web3.eth.sendTransaction({
            gasPrice: web3.utils.toHex(gasPrice),
            gas: web3.utils.toHex(gasLimit),
            to: presaleContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });


        return {
            status: true,
            hash: txData.transactionHash
        }
    } catch (error) {
        return {
            status: false,
            message: error.toString()
        }
    }
};




export const BlockchainClaimToken = async (req) => {
    try {
        const { walletProvider, walletAddress, presaleContract } = req;

        const validate = await validateProvider(walletProvider);
        if (!validate.status) {
            return validate;
        }
        let web3 = validate.web3;
        let chainId = web3Config.CHAIN;

        let preContract = new web3.eth.Contract(PreSaleAbi, presaleContract);



        let isAirdropActive = await preContract.methods.isAirdropActive().call();
        if (!isAirdropActive) {
            return {
                status: false,
                message: `Presale token allocation not started`,
            }
        }

        let trx = await preContract.methods.claimINFI();

        let encodeData = trx.encodeABI();
        let gasPrice = await web3.eth.getGasPrice();

        let gasLimit = await web3.eth.estimateGas({
            gasPrice: web3.utils.toHex(gasPrice),
            to: presaleContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });

        const txData = await web3.eth.sendTransaction({
            gasPrice: web3.utils.toHex(gasPrice),
            gas: web3.utils.toHex(gasLimit),
            to: presaleContract,
            from: walletAddress,
            data: encodeData,
            chainId: chainId,
        });


        return {
            status: true,
            hash: txData.transactionHash
        }
    } catch (error) {
        return {
            status: false,
            message: error.toString()
        }
    }
};
